export default () => {
	return {
		logoCreatorFunction: undefined,
		localStorageLoaded: false,
		sdkInited: false,
		emailEditorInited: false,
		emailPreviewInited: false,
		htmlImportInited: false,
		galleryInited: false,
		variableEditorInited: false,
		thumbnailInited: false,
	};
};
